import { BottomNavigation } from "../../molcules/BottomNavigation";
import { MoreHeader } from "../../molcules/Header";
import * as S from "./moreTemplates.styles";

interface MainProps {
  pageTitle?: string;
  pageHeaderTitle?: string;
  background?: string;
  padding?: string;
  headerBg?: string;
  children: React.ReactElement;
  gap?: string;
  showActionButton?: boolean;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
}

export const MoreTemplates = ({
  pageTitle,
  pageHeaderTitle,
  background,
  padding,
  headerBg,
  children,
  gap,
  showActionButton = false,
  actionButtonText,
  onActionButtonClick,
}: MainProps) => {
  return (
    <S.MoreTemplates>
      <S.ContentNavigation headerBg={headerBg}>
        <MoreHeader
          pageTitle={pageTitle}
          pageHeaderTitle={pageHeaderTitle}
          showActionButton={showActionButton}
          actionButtonText={actionButtonText}
          onActionButtonClick={onActionButtonClick}
        />
      </S.ContentNavigation>
      <S.ContentsSection background={background} padding={padding} gap={gap}>
        {children}
      </S.ContentsSection>
    </S.MoreTemplates>
  );
};
